/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TMessagesUnreadModel,
  IMessagesUnreadRequest,
  IMappers,
  IMessagesUnreadResponse,
  IMessagesUnreadResponseError,
  TMessagesUnreadResponse,
} from './types';

const defaultConfig: TMessagesUnreadModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v1/messages/unread/',
  hostType: 'api',
} as TMessagesUnreadModel;

function createMessagesUnreadModel(parameters: IMessagesUnreadRequest): TMessagesUnreadModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IMessagesUnreadOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IMessagesUnreadRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchMessagesUnread<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IMessagesUnreadOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TMessagesUnreadResponse> {
  const { response, statusCode } = await httpApi.fetch(createMessagesUnreadModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMessagesUnreadResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IMessagesUnreadResponseError);
    }
  }

  return { response, statusCode } as TMessagesUnreadResponse;
}

export { defaultConfig, createMessagesUnreadModel, fetchMessagesUnread };
